







































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import cloneDeep from 'lodash/cloneDeep'
import listMixin from '@/mixins/list'
import configurationApi from '@/api/configuration'
import visitorApi from '@/api/visitor'
import { passwordReg } from '@/utils/regExp'
import { formatDate } from '@/web-task/filter'
import Upload from '@/components/Upload/index.vue'
import { uuid, download } from '@/utils/util'

@Component({
	name: 'Holiday',
	components: {
		PageLayout,
		Upload,
	},
})
export default class Configuration extends Mixins(listMixin) {
	private columns: any = [
		{
			title: '序号',
			align: 'center',
			dataIndex: 'key',
			scopedSlots: { customRender: 'key' },
		},
		{
			title: '行政区域',
			align: 'center',
			dataIndex: 'location',
			width: 200,
		},
		{
			title: '参照物名称',
			align: 'center',
			dataIndex: 'poi',
			width: 160,
		},
		{
			title: '参照物经纬度',
			align: 'center',
			dataIndex: 'orginCoordinate',
			// scopedSlots: { customRender: 'coordinate' },
			width: 200,
		},
		{
			title: '级别',
			align: 'center',
			dataIndex: 'level',
			scopedSlots: { customRender: 'level' },
			width: 120,
		},
	]
	private tableData: any = []
	private importing = false
	private exporting = false

	public created() {
		this.getList()
	}

	private downloadTemplate() {
		const a = document.createElement('a')
		a.href = '/结算参照物管理模板.xlsx'
		a.download = '结算参照物管理模板.xlsx'
		a.click()
		a.remove()
	}

	private async importTemplate() {
		const res = await (this.$refs.upload as any).getSingle()

		this.importing = true
		const formData = new FormData()
		formData.append('file', res)
		await configurationApi.settlementImport(formData).finally(() => {
			this.importing = false
		})
		this.$message.success('导入成功')
		this.getList()
	}

	private exportTemplate() {
		this.exporting = true
		configurationApi
			.settlementExport()
			.then((file: any) => {
				download(file.data, file.filename)
			})
			.finally(() => {
				this.exporting = false
			})
	}

	public async getList() {
		this.$nextTick(async () => {
			const res = await configurationApi.getSettlementList({
				pageSize: 8888,
				pageNum: 1,
			})
			this.tableData = res.data.retList.map((item: any) => {
				return {
					...item,
					key: uuid(),
				}
			})
		})
	}
}
